module.exports = __webpack_public_path__ + "img/strength.8703b2aa.svg";